export default __webpack_public_path__ + "static/media/image.8a1c405d.png";